import { render } from "./App.vue?vue&type=template&id=ef6b4b30"
const script = {}

import "./App.vue?vue&type=style&index=0&id=ef6b4b30&lang=css"

import exportComponent from "/var/jenkins_home/workspace/reselect.konnektor.nl_acceptance/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.39_vue@3.2.39_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__